module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/server-5c1e36d184d44cba6f7e0c1c710dadfb.svg";